import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { HowWeIntegrateSection } from "@/components/sections/HowWeIntegrateSection";
import { CTASection } from "@/components/sections/CTASection";
import { SEO } from "@/components/SEO";

const HowWeWork = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="How We Work | It's All About Growth"
        description="An async-first, milestone-based engagement model with a 60/90 day arc — direct partner access, pre-reads over meetings, capability you keep."
        path="/how-we-work"
      />
      <Header />
      <main className="pt-20">
        <HowWeIntegrateSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HowWeWork;
